'use strict';

var payUHelper = require('./payUHelper');
var payUApi = require('int_payu/payUApi.js');
var joinSchemeLogin = require('../savingSchemes/joinSchemeLogin');

$(document).ready(function () {
    payUHelper.injectPayUBillingSDK();
    $('body').on('click', '.scheme-payment.initiate-payment', function () {
        var urlPayU = $('.getpayUdetails').attr('data-url');
        var callbackurl = $('.payUhandlecallback').attr('data-url');
        var dismissalUrlPayU = $('.onDismissalPayU').attr('data-url');
        var payUFailureUrl = $('.payUFailureUrl').attr('data-url');
        $.spinner().start();

        var paymentInfoForm = {
            finalAmount: $('.final-amount').val(),
            finalWeight: $('.final-weight').val(),
            bonusWeight: $('.bonus-weight').val(),
            bonusAmount: $('.bonus-amount').val(),
            nomineeName: $('#customer-nominee-name').val(),
            nomineeRelation: $('.nominee-relation').val(),
            referralCode: $('#customer-referral-code').val(),
            promoCode: $('#customer-promocode').val(),
            schemeDetails: $('.scheme-details').val(),
            promoAmount: $('.promo-amount').val(),
            joinDate: $('.join-date').val(),
            empReferralCode: $('.employee-referral-code').val(),
            referralAmount: $('.referral-amount').val(),
            passBookNo: $('#passbookNo').val(),
            schemeCode: $('.scheme-code').val(),
            schemeName: $('.scheme-name').val(),
            type: $('.scheme-type').val(),
            callbackUrl: callbackurl,
            dismissalUrl: dismissalUrlPayU,
            failureUrl: payUFailureUrl
        };

        $.ajax({
            url: urlPayU,
            method: 'POST',
            data: paymentInfoForm,
            success: function (data) {
                $.spinner().stop();
                if (joinSchemeLogin.isLoggedOutResponse(data)) {
                    // Session expired: reloading the join form logs in again and continues
                    window.location.reload();
                    return;
                }
                if (data.error === false && data.schemeSaved === true) {
                    var options = payUHelper.createPayUOptions(callbackurl, data);
                    var handlers = {
                        responseHandler: function (BOLT) {
                            if (BOLT.response.txnStatus === 'SUCCESS') {
                                $.spinner().start();
                                payUApi.updateSuccessPayUStatus(BOLT.response, data.paymentData);
                            } else if (BOLT.response.txnStatus === 'FAILED') {
                                payUApi.callDismissalHandler(BOLT.response, dismissalUrlPayU);
                            } else if (BOLT.response.txnStatus === 'CANCEL') {
                                payUApi.callDismissalHandler(BOLT.response, dismissalUrlPayU);
                            }
                        },

                        catchException: function () {
                            $.spinner().start();
                        }
                    };

                    // eslint-disable-next-line no-undef
                    bolt.launch(options, handlers);
                } else if (data.schemeSaved === false && data.schemedetails.success === false) {
                    $('body').trigger('failureToast', data.schemedetails.message);
                } else {
                    $.spinner().stop();
                    $('.error-message').removeClass('d-none').text(
                        data.message || 'Unable to save scheme. Please try again.'
                    );
                }
            },
            error: function (xhr) {
                $.spinner().stop();
                joinSchemeLogin.handleAccessDenied(xhr);
            }
        });
    });
});
